"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _createForOfIteratorHelper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TDocumentCtor = void 0;
var _HTMLElementModel = _interopRequireDefault(require("../model/HTMLElementModel"));
var _domUtils = require("../dom/dom-utils");
var _TBlockCtor = _interopRequireDefault(require("./TBlockCtor"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var defaultContextBase = Object.freeze({
  baseHref: 'about:blank',
  baseTarget: '_self',
  charset: 'utf-8',
  title: '',
  lang: 'en',
  dir: 'ltr',
  links: [],
  meta: []
});
function getDefaultDocumentContext() {
  return Object.assign({}, defaultContextBase, {
    links: [],
    meta: []
  });
}
function extractContextFromHead(head, lang, dir) {
  var context = getDefaultDocumentContext();
  if (lang) {
    context.lang = lang;
  }
  if (dir) {
    context.dir = 'rtl';
  }
  var domNode = head.domNode;
  var children = domNode.children;
  children.filter(_domUtils.isDomElement).forEach(function (child) {
    if (child.tagName === 'meta') {
      if (child.attribs.name) {
        context.meta.push(child.attribs);
      } else if (child.attribs.charset) {
        context.charset = child.attribs.charset.toLowerCase();
      }
    } else if (child.tagName === 'link') {
      context.links.push(child.attribs);
    } else if (child.tagName === 'title') {
      var _iterator = _createForOfIteratorHelper(child.children.filter(_domUtils.isDomText)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var titleChild = _step.value;
          context.title = titleChild.data.trim();
          break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (child.tagName === 'base') {
      context.baseHref = child.attribs.href || context.baseHref;
      context.baseTarget = child.attribs.target || context.baseTarget;
    }
  });
  return context;
}
var htmlModel = _HTMLElementModel.default.fromNativeModel({
  tagName: 'html',
  category: 'grouping'
});
var TDocumentCtor = function TDocument(init) {
  this.initialize(init);
};
exports.TDocumentCtor = TDocumentCtor;
TDocumentCtor.prototype = Object.create(_TBlockCtor.default.prototype);
Object.defineProperty(TDocumentCtor.prototype, 'tagName', {
  value: 'html',
  writable: false
});
Object.defineProperty(TDocumentCtor.prototype, 'type', {
  value: 'document',
  writable: false
});
Object.defineProperty(TDocumentCtor.prototype, 'displayName', {
  value: 'TDocument',
  writable: false
});
Object.defineProperty(TDocumentCtor.prototype, 'elementModel', {
  value: htmlModel,
  writable: false
});
TDocumentCtor.prototype.parseChildren = function parseChildren() {
  var head;
  var _iterator2 = _createForOfIteratorHelper(this.children),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      if (child.tagName === 'head') {
        head = child;
        break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  this.context = Object.freeze(head ? extractContextFromHead(head, this.attributes.lang, this.attributes.dir) : _objectSpread(_objectSpread({}, getDefaultDocumentContext()), {}, {
    lang: this.attributes.lang,
    dir: this.attributes.dir
  }));
};
var _default = TDocumentCtor;
exports.default = _default;